import React, { PropsWithChildren } from 'react';
import './row.scss';

function RowComponent({
    children,
    ...props
}: PropsWithChildren<React.HTMLProps<HTMLDivElement>>) {
    return (
        <div {...props} className={`row ${props.className ?? ''}`}>
            {children}
        </div>
    );
}

export default RowComponent;
